import { createUseAppTranslation } from '@sib/i18n';

export const useTasksAppTranslation = createUseAppTranslation('tasks');
